import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const CoCurriculum = () => {
     useEffect(() => {
        document.title = 'Co-Curriculum -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  Academics  </li> 
     <li>Co-Curriculum </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Co-Curriculum  </h1>
         </div>
     </div>
     <div className="row Curriculum">
          <h3>Art & Craft</h3>
       <div className="col-xl-3 col-lg-4 col-md-6 col-12">
       <LazyLoad>
           <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum.jpg">
               <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum.jpg" className="img-fluid" alt="STPCSH"/>
           </a>
       </LazyLoad>
       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-12">
       <LazyLoad>
           <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum1.jpg">
               <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum1.jpg" className="img-fluid" alt="STPCSH"/>
           </a>
       </LazyLoad>
       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-12">
       <LazyLoad>
           <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum2.jpg">
               <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum2.jpg" className="img-fluid" alt="STPCSH"/>
           </a>
       </LazyLoad>
       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-12">
       <LazyLoad>
           <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum3.jpg">
               <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum3.jpg" className="img-fluid" alt="STPCSH"/>
           </a>
       </LazyLoad>
       </div>
       <h3>Music & Dance</h3>
       <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <LazyLoad>
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum4.jpg">
                <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum4.jpg" className="img-fluid" alt="STPCSH"/>
            </a>
        </LazyLoad>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <LazyLoad>
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum5.jpg">
                <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum5.jpg" className="img-fluid" alt="STPCSH"/>
            </a>
        </LazyLoad>
        </div>
        <h3>Indoor Sports</h3>
        <p>Carrom is a tabletop game of Indian origin in which players flick discs, attempting to knock them to the corners of the board. The game is very popular in the Indian subcontinent and is known by various names in different languages. In South Asia, many clubs and cafés hold regular tournaments. Carrom is very commonly played by families, including children, and at social functions. Different standards and rules exist in different areas. It became very popular in the United Kingdom and the Commonwealth during the early 20th century</p>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <LazyLoad>
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum6.jpg">
                <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum6.jpg" className="img-fluid" alt="STPCSH"/>
                <p>Carrom</p>
            </a>
        </LazyLoad>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <LazyLoad>
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum7.jpg">
                <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum7.jpg" className="img-fluid" alt="STPCSH"/>
                <p>Table Tennis</p>
            </a>
        </LazyLoad>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <LazyLoad>
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum8.jpg">
                <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum8.jpg" className="img-fluid" alt="STPCSH"/>
                <p>Chess</p>
            </a>
        </LazyLoad>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
        <LazyLoad>
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum9.jpg">
                <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum9.jpg" className="img-fluid" alt="STPCSH"/>
                <p>Yoga</p>
            </a>
        </LazyLoad>
        </div>
           <h3>Outdoor Sports</h3>
           <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum10.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum10.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>Archery</p>
                </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum11.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum11.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>Karate</p>
                </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum12.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum12.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>Skating</p>
                </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum13.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum13.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>Baseball</p>
                </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum14.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum14.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>Cricket</p>
                </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum15.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum15.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>Basketball</p>
                </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum16.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum16.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>Football</p>
                </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum17.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum17.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>Taekwondo</p>
                </a>
            </LazyLoad>
            </div>
            <h3>Scouts & Guides</h3>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum18.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum18.jpg" className="img-fluid" alt="STPCSH"/>
                    
                </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum19.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Curriculum19.jpg" className="img-fluid" alt="STPCSH"/>
                    
                </a>
            </LazyLoad>
            </div>
      </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default CoCurriculum
